module.exports = __webpack_public_path__ + "img/privilege.7c39ee54.png";